<template>
  <div class="enhancify">
      <h1>Users</h1>
      <b-tabs class="modern-tab" v-model="activeTab">
        <b-tab-item label="Customers" v-if="checkAccess(p.manage.users.contractors.access)">
          <keep-alive>
            <Customers v-if="activeTab === 0" />
          </keep-alive>
        </b-tab-item>
        <b-tab-item label= "Partners" v-if="checkAccess(p.manage.users.partners.access)">
          <keep-alive>
            <Partners v-if="activeTab === 1" />
          </keep-alive>
        </b-tab-item>
      </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import permission from '../../../assets/Permissions';
import Partners from './UserPartners.vue';
import Customers from './UserCustomers.vue';

/**
 * todo: зачем убрали табы?
 * Имхо более практичным решением было тут добавить 2 роута
 * /manage/users/customers
 * /manage/users/partners
 * И доступы к этим роутам уже через guard  решаить,
 * сейчас тут дублируются проверки привелегий по кнопкам + active но ничего не мешает
 * сдлеать activeTab в другом месте люибым, guard бы это глобально отрубил
 */
export default {
  name: 'ManageUsers',
  components: { Customers, Partners },
  data() {
    return {
      p: permission,
      activeTab: 0,
    };
  },

  activated() {
    if (this.activeTab === 0
      && !this.checkAccess(this.p.manage.users.contractors.access)) {
      this.activeTab = 1;
    }
  },

  computed: {
    ...mapGetters({
      checkAccess: 'authAuthenticator',
    }),
  },

  methods: {
  },
};
</script>

<style lang="stylus" scoped>
.tabs
  display flex
  justify-content start
  border-bottom 1px solid rgba(143, 167, 179, 0.3)
  overflow visible
  font-size 18px
  .tab
    cursor pointer
    margin 0 15px
    padding-bottom: 18px
    &:first-child
      margin: 0 15px 0 0
    &.is-active
      position relative
      font-weight 700
      &:after
        content: ''
        position absolute
        bottom -1.5px
        left 0
        width 100%
        height 3px
        background rgba(23, 181, 72, 1)
</style>
